import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { prepareImageForEditing } from '~core/image';
import initChangeClothes from './initChangeClothes';
import displayClothes from './displayClothes';
import { handleTabImagesAI } from '~src/sidebar';
import { fetchClothes } from '~graphql/controllers';
import {
  clothesTranslations,
  colorTranslations,
} from '~core/changeClothes/localizazion';
import { showSidebarTab } from '~src/sidebarLegacy';
import { isPlaceholderEditing } from '~core/magicFrame';
import { checkAiCreditsBeforeUse } from '~core/aiCredits';

export default async function startChangeClothes() {
  // Check credits before entering the feature
  const hasCredits = await checkAiCreditsBeforeUse({
    featureName: 'Change Clothes',
    requiredCredits: 1,
  });

  if (!hasCredits) {
    return;
  }

  // Initialize change clothes
  initChangeClothes();

  // Get current selection
  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  const imageUrl = await prepareImageForEditing(selection, false);

  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  // Store original state
  modifyState('changeClothesOriginalImage', imageUrl);
  modifyState('changeClothesSelection', selection);
  modifyState('ischangeClothesActive', true);

  // Show change clothes sidebar tab
  showSidebarTab('change-clothes');

  // Show the garments container
  $('#sidebar-box-change-clothes-container').show();

  // Scroll sidebar to top
  $('#sidebar-content').scrollTop(0);

  // Load and display garments using existing GraphQL query
  try {
    const gender = getState('changeClothesGender');

    // Activate the correct gender tab
    if (gender === 'f') {
      // Activate Donna tab
      $('[data-sidebar-tab-target-name="change-clothes-uomo"]')
        .removeClass('buttonSidebarTabActive')
        .addClass('buttonSidebarTabDisable');
      $('[data-sidebar-tab-target-name="change-clothes-donna"]')
        .removeClass('buttonSidebarTabDisable')
        .addClass('buttonSidebarTabActive');

      // Show Donna container, hide Uomo
      $('[data-sidebar-tab-name="change-clothes-uomo"]')
        .removeClass('active')
        .addClass('inactive');
      $('[data-sidebar-tab-name="change-clothes-donna"]')
        .removeClass('inactive')
        .addClass('active');
    } else {
      // Activate Uomo tab (default)
      $('[data-sidebar-tab-target-name="change-clothes-donna"]')
        .removeClass('buttonSidebarTabActive')
        .addClass('buttonSidebarTabDisable');
      $('[data-sidebar-tab-target-name="change-clothes-uomo"]')
        .removeClass('buttonSidebarTabDisable')
        .addClass('buttonSidebarTabActive');

      // Show Uomo container, hide Donna
      $('[data-sidebar-tab-name="change-clothes-donna"]')
        .removeClass('active')
        .addClass('inactive');
      $('[data-sidebar-tab-name="change-clothes-uomo"]')
        .removeClass('inactive')
        .addClass('active');
    }

    const clothes = await fetchClothes({
      forceFetch: false,
      gender,
      limit: 10000,
    });

    if (clothes && clothes.length > 0) {
      modifyState('changeClothesClothes', clothes);

      // Populate filter options based on available clothes
      const categories = [
        ...new Set(clothes.map((cloth) => cloth.item || '')),
      ].sort();
      const colors = [
        ...new Set(clothes.map((cloth) => cloth.color || '')),
      ].sort();

      // Update category filter
      const categoryFilter = $('#change-clothes-filter-category');
      // Clear all existing options except "all"
      categoryFilter.find('option:not([value="all"])').remove();

      // Create array of objects with original and translated values
      const translatedCategories = categories
        .filter(Boolean)
        .map((category) => ({
          value: category,
          label: clothesTranslations[category.toLowerCase()] || category,
        }));

      // Sort by Italian translation
      translatedCategories.sort((a, b) => a.label.localeCompare(b.label, 'it'));

      // Append sorted options
      translatedCategories.forEach(({ value, label }) => {
        categoryFilter.append(`<option value="${value}">${label}</option>`);
      });

      // Update color filter with color squares
      const colorContainer = $('#change-clothes-color-squares');
      colorContainer.empty();

      // Add "All" option
      colorContainer.append(`
        <div class="change-clothes-color-square active" data-color="all" title="Tutti i colori">
          <div class="change-clothes-color-square-inner change-clothes-all-colors">
            <span>Tutti</span>
          </div>
        </div>
      `);

      colors.forEach((color) => {
        if (color) {
          const colorData = colorTranslations[color.toLowerCase()];
          if (colorData) {
            colorContainer.append(`
              <div class="change-clothes-color-square" data-color="${color}" title="${
              colorData.it
            }">
                <div class="change-clothes-color-square-inner" style="background-color: ${
                  colorData.hexColor
                }">
                  ${
                    colorData.hexColor === '#FFFFFF'
                      ? '<div class="change-clothes-white-border"></div>'
                      : ''
                  }
                </div>
              </div>
            `);
          }
        }
      });

      displayClothes(gender, clothes);
    }
  } catch (error) {
    console.error('Error loading clothes:', error);
  }

  // Make sure we're on the AI tab
  handleTabImagesAI();
}
